/**
 * Module that serves as a wizard for creating API request or transformation actions
 */
define([
  "marionette",
  "messaging/messenger",
  "./actionItemModalView",
  "./actionItemStep/actionItemStepModule",
  "./actionItemSelect/actionItemSelectModule",
  "./apiRequestItem/apiRequestItemModule",
  "./transformationActionItem/transformationActionItemModule",
  "./apiRequestValidation/apiRequestValidationModule",
  "./apiResponse/apiResponseModule",
], function (
  Marionette,
  Messenger,
  ActionItemModalView,
  ActionItemStepModule,
  ActionItemSelectModule,
  ApiRequestItemModule,
  TransformationActionItemModule,
  ApiRequestValidationModule,
  ApiResponseModule,
) {
  var ActionItemModalModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "actionItemModal";
      this.region = options.region;
      this.editMode = options.editMode;
      this._setUpVents();
    },
    show: function (bundle) {
      var actionItemCollection = bundle.actionItems;
      var actionItem = bundle.item; //only exists if editing an item

      this.layout = new ActionItemModalView.actionItemModalLayout();
      this.actionItemStep = this.addSubModule(
        new ActionItemStepModule({ region: this.layout.actionItemStep, editMode: this.editMode }),
      );
      this.actionItemSelect = this.addSubModule(
        new ActionItemSelectModule({ region: this.layout.actionItemSelect }),
      );
      this.apiRequestItem = this.addSubModule(
        new ApiRequestItemModule({ region: this.layout.actionItemSelect }),
      );
      this.transformationActionItem = this.addSubModule(
        new TransformationActionItemModule({ region: this.layout.actionItemSelect }),
      );
      this.apiRequestValidation = this.addSubModule(
        new ApiRequestValidationModule({ region: this.layout.actionItemSelect }),
      );
      this.apiResponse = this.addSubModule(
        new ApiResponseModule({ region: this.layout.actionItemSelect }),
      );

      this.layout.on(
        "done",
        function () {
          this.openModule.isValid(function () {
            if (actionItem) {
              //update edited item using the modified clone object in the submodule
              actionItem.set(this.openModule.getActionItem().attributes);
            } else {
              //add new item
              actionItemCollection.addItem(this.openModule.getActionItem());
            }
            Messenger.vent.trigger("close:modal");
          }, this);
        },
        this,
      );

      this.layout.on(
        "back",
        function () {
          if (this.openModule === this.apiResponse) {
            Messenger.vent.trigger("api:request:validation", this.openModule.getActionItem());
          } else if (this.openModule === this.apiRequestValidation) {
            Messenger.vent.trigger("edit:api:request", this.openModule.getActionItem());
          } else {
            this.actionItemStep.setActionItemType(""); //item type not determined yet
            this.actionItemStep.setActiveStep(1);
            this._showBeginningPage();
          }
        },
        this,
      );

      this.layout.on(
        "next",
        function () {
          this.openModule.isValid(function () {
            if (this.openModule === this.apiRequestItem) {
              Messenger.vent.trigger("api:request:validation", this.openModule.getActionItem());
            } else if (this.openModule === this.apiRequestValidation) {
              Messenger.vent.trigger("api:response", this.openModule.getActionItem());
            }
          }, this);
        },
        this,
      );

      this.layout.on(
        "cancel",
        function () {
          Messenger.vent.trigger("close:modal");
        },
        this,
      );

      this.layout.on(
        "show",
        function () {
          this._showSubViews(actionItem);
        },
        this,
      );

      this.showRegion(this.layout);
    },
    _showSubViews: function (actionItem) {
      this.actionItemStep.show();
      if (actionItem) {
        //clone the action item so that we can cancel any changes that are made in the modal
        var actionItemClone = actionItem.clone();
        if (actionItem.get("actionType") === 0) {
          Messenger.vent.trigger("edit:transformation:action", actionItemClone);
        } else {
          Messenger.vent.trigger("edit:api:request", actionItemClone);
        }
      } else {
        this._showBeginningPage();
      }
    },
    _showBeginningPage: function () {
      this.layout.hideBackButton();
      this.layout.hideNextButton();
      this.layout.hideDoneButton();
      this.actionItemSelect.show();
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "edit:api:request",
        function (apiRequestItem) {
          this.openModule = this.apiRequestItem;
          this.apiRequestItem.show(apiRequestItem);
          this.actionItemStep.setActionItemType("apiRequest");
          this.actionItemStep.setActiveStep(2);
          if (this.editMode) {
            this.layout.hideBackButton();
          } else {
            this.layout.showBackButton();
          }
          this.layout.showNextButton();
          this.layout.hideDoneButton();
        },
        this,
      );

      Messenger.vent.on(
        "api:request:validation",
        function (apiRequestItem) {
          this.openModule = this.apiRequestValidation;
          this.apiRequestValidation.show(apiRequestItem);
          this.actionItemStep.setActiveStep(3);
          this.layout.showBackButton();
          this.layout.showNextButton();
          this.layout.hideDoneButton();
        },
        this,
      );

      Messenger.vent.on(
        "api:response",
        function (apiRequestItem) {
          this.openModule = this.apiResponse;
          this.apiResponse.show(apiRequestItem);
          this.actionItemStep.setActiveStep(4);
          this.layout.showBackButton();
          this.layout.hideNextButton();
          this.layout.showDoneButton();
        },
        this,
      );

      Messenger.vent.on(
        "edit:transformation:action",
        function (transformationActionItem) {
          this.openModule = this.transformationActionItem;
          this.transformationActionItem.show(transformationActionItem);
          this.actionItemStep.setActionItemType("transformation");
          this.actionItemStep.setActiveStep(2);
          if (this.editMode) {
            this.layout.hideBackButton();
          } else {
            this.layout.showBackButton();
          }
          this.layout.hideNextButton();
          this.layout.showDoneButton();
        },
        this,
      );
    },
  });

  return ActionItemModalModule;
});
